import React from 'react';
import {
    ColumnDatatable,
    PreFilterDatatableList,
    RowSelectionAction,
} from '@europrocurement/flexy-datatable';

import useFactureFilters, {
    FactureStatus,
} from '@europrocurement/l2d-modules/modules/Factures/hooks/useFactureFilters';
import { useFactureColumns, usePanierPay } from '@europrocurement/l2d-modules';
import { FactureOpenSearch } from '@europrocurement/l2d-domain';
import { useSnackbar } from 'notistack';
import ActionMenuListInvoicesBack from '../views/list/actionMenu/ActionMenuListInvoicesBack';

const useFormalitiesInvoicesBackHook = ({ ddmIdFilter }: { ddmIdFilter?: number }) => {
    const { formalitiesInvoicesColumnsBack } = useFactureColumns();

    const { navigateFacturePay } = usePanierPay();
    const { enqueueSnackbar } = useSnackbar();
    const actionColumnFormalityInvoiceBack: ColumnDatatable = {
        label: 'Actions',
        displayLabel: false,
        render: (facture: FactureOpenSearch) => <ActionMenuListInvoicesBack facture={facture} />,
        isDisplayed: true,
        sortable: false,
        sx: {
            display: {
                xs: 'none',
                sm: 'none',
                md: 'table-cell',
                lg: 'table-cell',
                xl: 'table-cell',
            },
        },
    };
    formalitiesInvoicesColumnsBack.push(actionColumnFormalityInvoiceBack);

    const { formalitiesInvoicesFiltersBack } = useFactureFilters({ ddmIdFilter });

    const rowActions: RowSelectionAction[] = [
        {
            icon: 'fa-credit-card',
            label: 'Payer ces factures',
            onClick: (items: Array<FactureOpenSearch>) => {
                if (!items || items.length === 0) return;

                // Vérifie que tous les clientId sont identiques
                const clientIds = items.map((item) => item.clientId);
                const uniqueClientIds = Array.from(new Set(clientIds));
                if (uniqueClientIds.length > 1) {
                    enqueueSnackbar(
                        'Erreur : les factures sélectionnées doivent être facturées au même client.',
                        { variant: 'error' },
                    );
                    return;
                }

                const ids = items.map((item) => item.id);

                navigateFacturePay(ids);
            },
        },
    ];

    const preFilters: PreFilterDatatableList = {
        label: 'Filtrer par statuts',
        items: [
            {
                label: 'Tout',
                filters: [],
            },
            {
                label: 'A régler',
                filters: [{ field: 'status', value: FactureStatus.TO_PAY }],
            },
            {
                label: 'En retard',
                filters: [{ field: 'status', value: FactureStatus.LATE }],
            },
            {
                label: 'Réglée',
                filters: [{ field: 'status', value: FactureStatus.PAYED }],
            },
            {
                label: 'Non payées',
                filters: [{ field: 'fPayee', value: false }],
            },
            {
                label: 'Factures mensuelles',
                filters: [{ field: 'fGroupee', value: true }],
            },
        ],
    };

    return {
        columns: formalitiesInvoicesColumnsBack,
        filters: formalitiesInvoicesFiltersBack,
        preFilters,
        rowActions,
    };
};

export default useFormalitiesInvoicesBackHook;
